import AboutSection from "./aboutSection";

export default AboutSection;